import Payment from '@hapana/shared/web/styles/assets/svgs/usd-circle-small.svg'
import Agreements from '@hapana/shared/web/styles/assets/svgs/file-alt-small.svg'
import Forms from '@hapana/shared/web/styles/assets/svgs/form.svg'
import Notes from '@hapana/shared/web/styles/assets/svgs/note-property.svg'
import Location from '@hapana/shared/web/styles/assets/svgs/location.svg'
import Birthday from '@hapana/shared/web/styles/assets/svgs/birthday.svg'
import Packages from '@hapana/shared/web/styles/assets/svgs/package-small.svg'
import FirstSession from '@hapana/shared/web/styles/assets/svgs/session.svg'
import IntroOffers from '@hapana/shared/web/styles/assets/svgs/offer.svg'
import Suspended from '@hapana/shared/web/styles/assets/svgs/user-small.svg'
// door.svg conveys "walked out / not back yet" — better metaphor for "days absent"
// than the original sleeping glyph (which read as "asleep").
import DaysAbsent from '@hapana/shared/web/styles/assets/svgs/door.svg'
import CustomAlertIcon from '@hapana/shared/web/styles/assets/svgs/bell-small.svg'
import type { AlertSystemType } from './alertSystem.types'

type Palette = { bg: string; icon: string }

export const ALERT_SYSTEM_TYPE_CONFIG: Record<
  AlertSystemType,
  {
    Icon: React.FC<React.SVGProps<SVGSVGElement>>
    colors: Palette
    order: number
  }
> = {
  // A red $ — staff must see money owed at a glance on the class list. Distinct from
  // the Booked tab's plain-$ Pay Now action.
  payment: {
    Icon: Payment,
    colors: { bg: 'alert.danger.lightest', icon: 'alert.danger.dark' },
    order: 1,
  },
  agreements: {
    Icon: Agreements,
    colors: { bg: 'pink.lightest', icon: 'pink.dark' },
    order: 2,
  },
  forms: {
    Icon: Forms,
    colors: { bg: 'alert.teal.lightest', icon: 'alert.teal.dark' },
    order: 3,
  },
  notesProps: {
    Icon: Notes,
    colors: { bg: 'alert.successV2.lightest', icon: 'alert.successV2.dark' },
    order: 4,
  },
  location: {
    Icon: Location,
    colors: { bg: 'alert.successV2.lightest', icon: 'alert.successV2.dark' },
    order: 5,
  },
  birthday: {
    Icon: Birthday,
    colors: { bg: 'alert.indigo.lightest', icon: 'alert.indigo.dark' },
    order: 6,
  },
  packages: {
    Icon: Packages,
    colors: { bg: 'alert.teal.lightest', icon: 'alert.teal.dark' },
    order: 7,
  },
  firstSession: {
    Icon: FirstSession,
    colors: { bg: 'alert.teal.lightest', icon: 'alert.teal.dark' },
    order: 8,
  },
  introOffers: {
    Icon: IntroOffers,
    colors: { bg: 'alert.teal.lightest', icon: 'alert.teal.dark' },
    order: 9,
  },
  suspended: {
    Icon: Suspended,
    colors: { bg: 'alert.danger.lightest', icon: 'alert.danger.dark' },
    order: 10,
  },
  daysAbsent: {
    Icon: DaysAbsent,
    colors: { bg: 'orange.lightest', icon: 'orange.dark' },
    order: 11,
  },
  destinationFee: {
    Icon: Payment,
    colors: { bg: 'orange.lightest', icon: 'orange.dark' },
    order: 12,
  },
  customAlert: {
    Icon: CustomAlertIcon,
    colors: { bg: 'alert.indigo.lightest', icon: 'alert.indigo.dark' },
    order: 13,
  },
}
